import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Row, Badge, Spinner, Alert, Button } from 'reactstrap';
import { H5, H6 } from '../../../AbstractElements';
import { getAdminById, getAdminId, isAuthenticated } from '../../../api/admin';
import { User, Shield, Clock, LogOut } from 'react-feather';

const AdminInfo = () => {
  const [adminInfo, setAdminInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentAdminId, setCurrentAdminId] = useState(null);

  useEffect(() => {
    fetchCurrentAdminInfo();
  }, []);

  const fetchCurrentAdminInfo = async () => {
    try {
      setLoading(true);
      setError(null);

      // Kiểm tra authentication
      if (!isAuthenticated()) {
        throw new Error('Chưa đăng nhập');
      }

      // Lấy admin ID hiện tại
      const adminId = getAdminId();
      if (!adminId) {
        throw new Error('Không tìm thấy thông tin admin');
      }

      setCurrentAdminId(adminId);

      // Lấy thông tin chi tiết admin
      const admin = await getAdminById(adminId);
      setAdminInfo(admin);

    } catch (err) {
      console.error('❌ Error loading admin info:', err);
      setError(err.message || 'Không thể tải thông tin admin');
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchCurrentAdminInfo();
  };

  if (loading) {
    return (
      <Col xxl="6" className="box-col-6">
        <Card>
          <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
            <div className="text-center">
              <Spinner color="primary" />
              <p className="mt-2 mb-0">Đang tải thông tin admin...</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  if (error) {
    return (
      <Col xxl="6" className="box-col-6">
        <Card>
          <CardBody>
            <Alert color="danger">
              <strong>Lỗi:</strong> {error}
            </Alert>
            <Button color="primary" size="sm" onClick={handleRefresh}>
              Thử lại
            </Button>
          </CardBody>
        </Card>
      </Col>
    );
  }

  if (!adminInfo) {
    return (
      <Col xxl="6" className="box-col-6">
        <Card>
          <CardBody>
            <Alert color="warning">
              Không tìm thấy thông tin admin
            </Alert>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xxl="6" className="box-col-6">
      <Card>
        <CardHeader className="card-no-border d-flex justify-content-between align-items-center">
          <H5>Thông Tin Admin</H5>
          <Button color="outline-primary" size="sm" onClick={handleRefresh}>
            <Clock size={16} className="me-1" />
            Làm mới
          </Button>
        </CardHeader>
        <CardBody>
          <div className="admin-profile">
            <div className="d-flex align-items-center mb-3">
              <div className="avatar-container me-3">
                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                     style={{ width: '60px', height: '60px' }}>
                  <User size={30} className="text-white" />
                </div>
              </div>
              <div className="admin-details">
                <H6 className="mb-1">{adminInfo.name || 'N/A'}</H6>
                <p className="text-muted mb-0">@{adminInfo.username || 'N/A'}</p>
                <Badge color={adminInfo.role_code === 'R1' ? 'success' : 'info'} className="mt-1">
                  <Shield size={14} className="me-1" />
                  {adminInfo.role_code === 'R1' ? 'Super Admin' : 'Admin'}
                </Badge>
              </div>
            </div>

            <Row className="g-3">
              <Col xs="6">
                <div className="info-item">
                  <small className="text-muted">ID Admin</small>
                  <p className="mb-0 f-w-500">{adminInfo.id || 'N/A'}</p>
                </div>
              </Col>
              <Col xs="6">
                <div className="info-item">
                  <small className="text-muted">Role Code</small>
                  <p className="mb-0 f-w-500">{adminInfo.role_code || 'N/A'}</p>
                </div>
              </Col>
              <Col xs="12">
                <div className="info-item">
                  <small className="text-muted">Trạng Thái</small>
                  <div className="mt-1">
                    <Badge color={adminInfo.isActive !== false ? 'success' : 'danger'}>
                      {adminInfo.isActive !== false ? 'Hoạt động' : 'Không hoạt động'}
                    </Badge>
                  </div>
                </div>
              </Col>
            </Row>

            {adminInfo.createdAt && (
              <div className="mt-3 pt-3 border-top">
                <small className="text-muted">
                  <Clock size={14} className="me-1" />
                  Tạo lúc: {new Date(adminInfo.createdAt).toLocaleString('vi-VN')}
                </small>
              </div>
            )}

            {adminInfo.updatedAt && (
              <div className="mt-1">
                <small className="text-muted">
                  <Clock size={14} className="me-1" />
                  Cập nhật: {new Date(adminInfo.updatedAt).toLocaleString('vi-VN')}
                </small>
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AdminInfo;
